import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { formatDate } from '../../assets/helper/dateFormatter';

const initialState = {
    startDate: moment().startOf("week").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    dates:{
        rangeLabel:"This month",
        start:formatDate(moment().startOf("week")),
        end:formatDate(moment())
    }
};

const dateRange = createSlice({
    name: 'dateRange',
    initialState,
    reducers: {
        setStartDate(state, action) {
            state.startDate = action.payload;
        },
        setEndDate(state, action) {
            state.endDate = action.payload;
        },
        setReportDates(state,action){
            state.dates=action.payload
        }
    },
});

export const { setStartDate,setEndDate,setReportDates } = dateRange.actions;
export default dateRange.reducer;
